import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import BookingsTabs from './bookings-tabs'
import { makeStyles } from '@material-ui/styles'
import { pageContentHorizontalGutters } from 'lib/styles/page-content-gutters'

export const useStyles = makeStyles(theme => ({
  root: pageContentHorizontalGutters(theme, {
    margin: 0,
    paddingTop: '28px',
    paddingBottom: 0,
    sm: {
      paddingTop: '20px',
    },
  }),
}))

const SchedulePage = ({ onboardingSchedule, onMetadataChange }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <BookingsTabs
            onboardingSchedule={onboardingSchedule}
            onMetadataChange={onMetadataChange}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default React.memo(SchedulePage)
